/**
 * Feature Flags
 *
 * Centralized feature flag configuration for the application.
 * These flags control the availability of various features at runtime.
 */

/**
 * Check if cookie consent banner is required (client-side).
 * Uses NEXT_PUBLIC_REQUIRES_COOKIE_CONSENT env var.
 * Set to 'true' for UK/EU deployments, 'false' for Australia.
 * Defaults to false (no banner required).
 */
export const requiresCookieConsent = (): boolean => {
  const envValue = process.env.NEXT_PUBLIC_REQUIRES_COOKIE_CONSENT
  return envValue === 'true'
}
